import { render, staticRenderFns } from "./ButtonBackHome.vue?vue&type=template&id=1f890ef0"
import script from "./ButtonBackHome.vue?vue&type=script&lang=js"
export * from "./ButtonBackHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports